import React from 'react';
import styled from 'styled-components';
import {labels} from '../../../../../../../util/utils';
import {IconoirArrowDown, IconoirArrowUp} from '@ey-xd/motif-icon';
import Icon from '../../../../../../Common/BaseComponentWrappers/MotifIcon';

export default function InherentRiskFactorsTableBottom() {
	return (
		<StyledInherentRiskFactorsTableBottom className="StyledALRAAsSertionsTableBottom">
			<section className="RisksTypesContainer">
				<span className="associated-to-inherentRiskFactor" />
				<span className="RiskLabel">{labels.ALRARiskRelatedToAssertion}</span>
			</section>
			<section className="RisksTypesContainer">
				<span className="risk high-risk">
					<Icon src={IconoirArrowUp} />
				</span>
				<span className="RiskLabel">{labels.ALRAGreaterExtent}</span>
			</section>
			<section className="RisksTypesContainer">
				<span className="risk low-risk">
					<Icon src={IconoirArrowDown} />
				</span>
				<span className="RiskLabel">{labels.ALRALesserExtent}</span>
			</section>
		</StyledInherentRiskFactorsTableBottom>
	);
}

const StyledInherentRiskFactorsTableBottom = styled.section`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	padding: var(--px-12);
	border: var(--px-1) solid var(--neutrals-200);
	border-top: 0 !important;
	border-radius: 0 0 var(--px-8) var(--px-8);
	background-color: var(--neutrals-00white);
	.RisksTypesContainer {
		display: inline-flex;
		align-items: center;
		& + .RisksTypesContainer {
			margin-left: var(--px-12);
		}
		.associated-to-inherentRiskFactor {
			height: var(--px-8);
			width: var(--px-8);
			background-color: var(--neutrals-300);
			border-radius: 50%;
			display: inline-block;
		}
	}
	.risk {
		background-color: #fff;
		color: #656579;
		border-radius: var(--px-4);
		font-size: var(--px-12);
		font-weight: 400;
		line-height: var(--px-20);
		display: inline-flex;
		justify-content: center;
		align-items: center;
		width: var(--px-20);
		height: var(--px-20);
		&.high-risk {
			border: var(--px-1) solid #b14891;
			background-color: #b14891;
			color: #fff;
			svg {
				color: #fff;
				cursor: auto;
				display: flex;
			}
		}
		&.low-risk {
			border: var(--px-2) solid #b14891;
			background: var(--neutrals-00white);
			color: var(--neutrals-1000);
			svg {
				color: var(--neutrals-1000);
				cursor: auto;
				display: flex;
			}
		}
		&.Tickcheckmark {
			background-color: transparent !important;
			svg {
				color: var(--neutrals-900);
			}
		}
	}
	.RiskLabel {
		font-size: var(--px-12);
		font-weight: 300;
		line-height: var(--px-16);
		color: #656579;
		margin-left: var(--px-8);
	}
`;
